<template>
	<j-card class="bg5">
		<div class="flex wrap xs-middle xs-12 p4">
			<!-- If logo, show it, otherwise show text -->
			<div class="xs-12">
				<img :src="insurerLogoUrl" height="40" />
				<div v-if="insurerLogoUrl" class="flex xs-12 xs-center md-left"></div>
				<template v-else>
					<div class="fs2 lh125 tt2 c6 fw7 mt1">{{ $t("insurer") }}</div>
					<div class="fw7 lh125">{{ insurerName }}</div>
				</template>
			</div>

			<!-- Name -->
			<div class="flex mt8 xs-12 xs-middle xs-between">
				<div>
					<div class="fs2 lh125 tt2 c6 fw7 mt1">{{ $t("name") }}</div>
					<div class="fw7 lh125">{{ name || "---" }}</div>
				</div>
				<div class="cu2" @click="$modal.show('editNameModal')">
					<crm-icon name="edit" color="c2" />
				</div>
			</div>

			<!-- Type -->
			<div class="xs-12 mt8">
				<div class="fs2 lh125 tt2 c6 fw7 mt1">{{ $t("type") }}</div>
				<div class="fw7 lh125">{{ type }}</div>
			</div>

			<!-- Plan -->
			<div class="xs-12 mt8">
				<div class="fs2 lh125 tt2 c6 fw7 mt1">{{ $t("plan") }}</div>
				<div class="fw7 lh125">{{ plan }}</div>
			</div>

			<!-- Version -->
			<div class="xs-12 mt8">
				<div class="fs2 lh125 tt2 c6 fw7 mt1">{{ $t("version") }}</div>
				<div class="fw7 lh125">{{ version ? version : "---" }}</div>
			</div>

			<!-- Action slot -->
			<div class="flex xs-12 mt8 md-right"></div>
			<slot name="action"></slot>
		</div>

		<core-modal :headline="$t('name')" name="editNameModal">
			<div class="p4">
				<div class="fw7 pb2">{{ $t("name") }}</div>
				<j-base-input-text v-model="form.name" />
				<j-button class="mt4" @click="updateName">{{ $t("update") }}</j-button>
			</div>
		</core-modal>
	</j-card>
</template>

<script>
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import JBaseInputText from "@/components/JBaseInputText/"
import CrmIcon from "@/components/CrmIcon"
import CoreModal from "@/modules/core/components/CoreModal"

import api from "../api/"

export default {
	components: { JCard, JButton, JBaseInputText, CrmIcon, CoreModal },

	props: {
		plan: String,
		version: {
			validator: val => typeof val === "string" || val === null,
			default: null
		},
		type: String,
		name: String,
		insurerName: String,
		insurerLogoUrl: String,
		selectedLocale: String
	},

	data() {
		return {
			form: {
				name: this.name
			}
		}
	},

	methods: {
		async updateName() {
			if (!this.form.name) return
			const l10n = {
				locale: this.selectedLocale,
				key: `products-${this.plan +
					"|" +
					this.version +
					"|" +
					this.type}-name`,
				value: this.form.name
			}

			this.isLoading = true
			const res = await api.localizeProduct({ l10n })
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}
			this.$modal.hide("editNameModal")
			this.$emit("updated")
		}
	}
}
</script>
